module.exports = __webpack_public_path__ + "img/1539025827.bdec8716.jpg";